import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-bootstrap4';
import Select from 'react-select';
import { DataContext } from '../../stores/teacher-table-store';
import { InputDebouncer, HandleExlFilter } from '../tables/shared/FilterEventHelpers';
import DatePicker, { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import { useTranslation } from 'react-i18next';
import { ACTIVE, INACTIVE, SHOW_ALL } from '../../i18n/keyConstants';
registerLocale('sv', sv);

const FilterCell = ({ column, children, ...restProps }) => {
    const columnName = column.name;
    const { store: { selectedFilters, filters, isResettingFilters, selectedTeacherStatus}, dispatch } = useContext(DataContext);
    const [chosenValue, setChosenValue] = useState(selectedFilters[columnName]);
    const intervalRef = useRef(null);
    const { t } = useTranslation(['shared']);

    const IsTextInputColumn = () => {
        return (columnName !== 'isActive');
    }

    const handleOptionValueChange = (selected) => {
        if (column.name === 'isActive') {
            { dispatch({ type: 'SELECTED_TEACHER_STATUS', payload: selected }) }
        }
    }

    useEffect(() => {
        if (IsTextInputColumn()) {
            if (!(chosenValue === selectedFilters[columnName])) {
                return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenValue]);

    useEffect(() => {
        if (isResettingFilters) {
            setChosenValue('');
            dispatch({ type: 'SELECTED_FILTERS_AND_FILTERS_RESET', columnName, payload: '' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);

    if (columnName === 'isActive') {
        if (selectedTeacherStatus[0]?.label === 'active') {
            selectedTeacherStatus[0].label = t(ACTIVE)
        }
        return (
            <th>
                <Select className="status-select"
                    isClearable={false}
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={selectedTeacherStatus}
                    options={[
                        { label: t(ACTIVE), value: 'true' },
                        { label: t(INACTIVE), value: 'false' },
                        { label: t(SHOW_ALL), value: '' },
                    ]}
                    onChange={(e) => {
                        HandleExlFilter(e, filters, handleOptionValueChange, columnName, 'equal', '', dispatch);
                    }}
                />
            </th>
        );
    }
    var FilterOptions = children[0];
    var TextInput = React.cloneElement(children[1], {
        value: chosenValue,
        onChange: (event) => {
            setChosenValue(event);
            children[1].props.onChange();
        }
    });

    return (
        <TableFilterRow.Cell
            column={column}
            {...restProps}>
            {FilterOptions}
            {TextInput}
        </TableFilterRow.Cell>
    );
}

export default FilterCell;
